import {
    Grid,
    Typography,
    Button,
    WithStyles,
    withStyles,
  } from "@material-ui/core";
  import {
    Link,
  } from 'react-router-dom';
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../styles";
  import {
    switchSelectedTab,
  } from "../actions/userActions";
  import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
  import { withRouter } from 'react-router-dom';
  interface TopHeaderProps extends WithStyles<typeof userStyles> {
      selectedTab: string;
      switchSelectedTab: any;
      isPostExpiryDays: any;
      toggleLicenseExpiredDialog: any;
      setLoggedInUser: any;
      history: any;
      isPostExpiryDaysProp: any;
  }
  
  class TopHeader extends Component<TopHeaderProps> {

    componentDidMount(){
      this.props.setLoggedInUser();
    }

    changeSelectedValue() {

      this.props.switchSelectedTab("");

    }
    renderClientHeader() {
      const { classes } = this.props;
      return (
        <>
          <Grid className={classes.topHeaderRoot}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Typography className={classes.headingFont}>Clients</Typography>
              </Grid>
              <Grid item>
              <Link
                to="/userManagement/addClient"
                style={{ textDecoration: 'none' }}
                onClick={this.changeSelectedValue}
              >
                <Button
                  variant="contained"
                  color="primary"
                >
                  Add New Client
                </Button>
              </Link>
              </Grid>
            </Grid>
          </Grid>
        </>
      );
    }

    renderRolesHeader() {
        const { classes } = this.props;
        return (
          <>
            <Grid className={classes.topHeaderRoot}>
              <Grid container justify="space-between" alignItems="center">
                <Grid item>
                  <Typography className={classes.headingFont}>Roles</Typography>
                </Grid>
                <Grid item>
                {/* <Link
                to="/userManagement/addRole"
                style={{ textDecoration: 'none' }}
                onClick={this.changeSelectedValue}

              > */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.handleAddnewRole()}
                  >
                    Add New Role
                  </Button>
                  {/* </Link> */}
                </Grid>
              </Grid>
            </Grid>
          </>
        );
    }
    renderUsersHeader() {
        const { classes } = this.props;
        return (
          <>
            <Grid className={classes.topHeaderRoot}>
              <Grid container justify="space-between" alignItems="center">
                <Grid item>
                  <Typography className={classes.headingFont}>Users</Typography>
                </Grid>
                <Grid item>
                {/* <Link
                to="/userManagement/addUser"
                style={{ textDecoration: 'none' }}
                onClick={this.changeSelectedValue}

              > */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleAddnewUser}
                  >
                    Add New User
                  </Button>
                  {/* </Link> */}
                </Grid>
              </Grid>
            </Grid>
          </>
        );
    }
    renderHeader() {
        const { selectedTab } = this.props;
        switch(selectedTab) {
            case "Clients": 
            return this.renderClientHeader();
            case "Roles": 
            return this.renderRolesHeader();
            case "Users": 
            return this.renderUsersHeader();
        }
    }

    handleAddnewRole = () => {
      const { isPostExpiryDaysProp } = this.props;
      
      if (this.props.isPostExpiryDays) {
        this.props.toggleLicenseExpiredDialog(true);
      } else {
        this.props.history.push('/userManagement/addRole');
      }
    }

    handleAddnewUser = () => {
      const { isPostExpiryDaysProp } = this.props;
      
      if (this.props.isPostExpiryDays) {
        this.props.toggleLicenseExpiredDialog(true);
      } else {
        this.props.history.push('/userManagement/addUser');
        this.props.switchSelectedTab("");
      }
    }
  
    render() {
      return (
        <div>
            {this.renderHeader()}
        </div>
      );
    }
  }
  
  const mapStateToProps = (state: any) => ({
    isPostExpiryDays: state.loginData.userData && state.loginData.userData.isPostExpiryDays
  });
  
  const mapDispatchToProps = {
    switchSelectedTab,
    setLoggedInUser,
    toggleLicenseExpiredDialog,
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
  )(withStyles(userStyles)(withRouter(TopHeader)));
  